import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { useBreakpoints } from "@qgiv/core-react";
import {
    selectReceipt,
    selectReceiptId,
} from "../../../redux/slices/receiptSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import ReceiptEventFooter from "./ReceiptEventFooter";

const ConnectedReceiptEventFooter = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;

    const receiptId = useSelector(selectReceiptId);
    const receipt = useSelector(selectReceipt);

    const { isSmallScreen } = useBreakpoints();

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.STANDARD_REGISTRATION_RECEIPT,
            state,
        ),
    );

    const {
        options: { displaySharingOptions },
    } = control;

    const receiptEventFooterProps = {
        receipt,
        displaySharingOptions: Number(displaySharingOptions),
        controlId,
        receiptId,
        isSmallScreen,
    };

    return <ReceiptEventFooter {...receiptEventFooterProps} />;
};

ConnectedReceiptEventFooter.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedReceiptEventFooter;
